"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportFieldTypeToJSON = exports.ReportFieldTypeFromJSONTyped = exports.ReportFieldTypeFromJSON = exports.ReportFieldType = void 0;
/**
 * Users can define a set of fields that they would like populated in the report. This enum
 * defines the global list of available fields. However, not all fields are applicable to
 * both report types. This is validated at request time.
 * The following fields are not allowed for insight reports:
 * - COMPLETION_RATE
 * - COMPLETES
 * - E_CPCL
 * - FIRST_QUARTILES
 * - FREQUENCY
 * - MIDPOINTS
 * - OFF_SPOTIFY_IMPRESSIONS
 * - PAID_LISTENS_FREQUENCY
 * - SKIPS
 * - SPEND
 * - STARTS
 * - THIRD_QUARTILES
 * - UNMUTES
 *
 * @export
 */
exports.ReportFieldType = {
    Clicks: 'CLICKS',
    Completes: 'COMPLETES',
    CompletionRate: 'COMPLETION_RATE',
    ConversionRate: 'CONVERSION_RATE',
    Ctr: 'CTR',
    ECpm: 'E_CPM',
    ECpcl: 'E_CPCL',
    FirstQuartiles: 'FIRST_QUARTILES',
    Frequency: 'FREQUENCY',
    Impressions: 'IMPRESSIONS',
    IntentRate: 'INTENT_RATE',
    Listeners: 'LISTENERS',
    Midpoints: 'MIDPOINTS',
    NewListeners: 'NEW_LISTENERS',
    NewListenerConversionRate: 'NEW_LISTENER_CONVERSION_RATE',
    NewListenerStreams: 'NEW_LISTENER_STREAMS',
    OffSpotifyImpressions: 'OFF_SPOTIFY_IMPRESSIONS',
    PaidListens: 'PAID_LISTENS',
    PaidListensFrequency: 'PAID_LISTENS_FREQUENCY',
    PaidListensReach: 'PAID_LISTENS_REACH',
    Reach: 'REACH',
    Skips: 'SKIPS',
    Spend: 'SPEND',
    Starts: 'STARTS',
    Streams: 'STREAMS',
    StreamsPerNewListener: 'STREAMS_PER_NEW_LISTENER',
    StreamsPerUser: 'STREAMS_PER_USER',
    ThirdQuartiles: 'THIRD_QUARTILES',
    VideoViews: 'VIDEO_VIEWS',
    VideoExpands: 'VIDEO_EXPANDS',
    VideoExpandRate: 'VIDEO_EXPAND_RATE',
    Unmutes: 'UNMUTES',
    PageViews: 'PAGE_VIEWS',
    Leads: 'LEADS',
    AddToCart: 'ADD_TO_CART',
    Purchases: 'PURCHASES',
    Revenue: 'REVENUE',
    AverageOrderValue: 'AVERAGE_ORDER_VALUE',
    ReturnOnAdSpend: 'RETURN_ON_AD_SPEND',
    CustomerAcquisitionCost: 'CUSTOMER_ACQUISITION_COST',
    CostPerLead: 'COST_PER_LEAD',
    StartCheckout: 'START_CHECKOUT',
    Products: 'PRODUCTS',
    SignUps: 'SIGN_UPS',
    CustomEvent1: 'CUSTOM_EVENT_1',
    CustomEvent2: 'CUSTOM_EVENT_2',
    CustomEvent3: 'CUSTOM_EVENT_3',
    CustomEvent4: 'CUSTOM_EVENT_4',
    CustomEvent5: 'CUSTOM_EVENT_5',
    ECpc: 'E_CPC',
    SkadAppInstalls: 'SKAD_APP_INSTALLS',
    KochavaAppInstalls: 'KOCHAVA_APP_INSTALLS',
    AppsflyerAppInstalls: 'APPSFLYER_APP_INSTALLS',
    StreamedImpressions: 'STREAMED_IMPRESSIONS'
};
function ReportFieldTypeFromJSON(json) {
    return ReportFieldTypeFromJSONTyped(json, false);
}
exports.ReportFieldTypeFromJSON = ReportFieldTypeFromJSON;
function ReportFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ReportFieldTypeFromJSONTyped = ReportFieldTypeFromJSONTyped;
function ReportFieldTypeToJSON(value) {
    return value;
}
exports.ReportFieldTypeToJSON = ReportFieldTypeToJSON;
